import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";
import ConsoleLogger from "../Utils/ConsoleLogger";
import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css';
import ReCAPTCHA from "react-google-recaptcha";
import Footer from "./Footer";


let config = require('../Config/appConfig.json');
let api_credentials_url = config.GET_API_CREDENTIALS;
let URL_SEND_EMAIL = config.SEND_MAIL_URL;
let KEY_SENDING_MAIL = config.KEY_SENDING_MAIL;
const context = "ContactForm.js";
const NOTIFICATION_TYPE_ERROR = "error";
const NOTIFICATION_TYPE_SUCCESS = "success";
let self = null;
@inject("appStore")
@observer
class ContactForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isCaptchaverified: false,
            name: "",
            email: "",
            subject: "",
            phone: "",
            message: ""
        };
    }

    componentWillMount = () => {
        self = this;
    }

    onNameChange = (event) => {
        this.setState({
            name: event.target.value
        })
    }

    onEmailChange = (event) => {
        this.setState({
            email: event.target.value
        })
    }

    onSubjectChange = (event) => {
        this.setState({
            subject: event.target.value
        })
    }

    onPhoneChange = (event) => {
        this.setState({
            phone: event.target.value
        })
    }

    onMessageChange = (event) => {
        this.setState({
            message: event.target.value
        })
    }

    onReCaptchaChange = (value) => {
        //console.log("ReCaptcha Value => ", value)
        if (value.length > 0) {
            //console.log("Verified")
            this.setState({
                isCaptchaverified: true
            })
        }
    }

    submitForm = () => {
        console.log("Submit Called");
        var isCaptchaverified = this.state.isCaptchaverified;
        var name = this.state.name;
        var email = this.state.email;
        var subject = this.state.subject;
        var phone = this.state.phone;
        var message = this.state.message;
        if (isCaptchaverified) {
            console.log("Name  => " + name);
            console.log("email  => " + email);
            console.log("subject  => " + subject);
            console.log("phone  => " + phone);
            console.log("message  => " + message);

            if (name == null || name == "" || name == undefined || name.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Name field is invalid");
            } else if (email == null || email == "" || email == undefined || email.length < 6 || email == "email@client.com" || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Email field is invalid");
            } else if (subject == null || subject == "" || subject == undefined || subject.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Subject field is invalid");
            } else if (phone == null || phone == "" || phone == undefined || phone.length < 10) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Phone field is invalid");
            } else if (message == null || message == "" || message == undefined || message.length < 10) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Message field is invalid");
            } else {
                var txt = "Name : ".concat(name);
                txt = txt.concat("\nEmail Id : ", email);
                txt = txt.concat("\nMobile : ", phone);
                txt = txt.concat("\nSubject : ", subject);
                txt = txt.concat("\nMessage: ", message);
                this.sendMail(txt, subject)
            }

        } else {
            this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Please verify the captcha")
        }
    }

    addNotifiation = (type, message) => {
        window.sendNotification(type, message)
    }

    sendMail = (text, subject) => {
        var info = {
            secret_key: KEY_SENDING_MAIL,
            subject: subject,
            text: text
        };
        fetch(URL_SEND_EMAIL, {
            method: 'POST',
            //headers: JSON.stringify(headers),
            body: JSON.stringify(info)
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (responseJson) {
                try {
                    var resJson = JSON.stringify(responseJson);
                    console.log("Success => " + resJson)
                    self.addNotifiation(NOTIFICATION_TYPE_SUCCESS, "Message sent successfully");
                } catch (e) {
                    console.log("1 Error => " + e)
                }
            })
            .catch(function (error) {
                console.log("2 Error => " + error)
            });
    }

    componentDidMount = () => {
        //console.log("PROPS", this.props);
    }
    render() {

        return (
            <div>
                <section className="pt-120 pb-120" id="contact_form">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="contact-info">
                                    <h3>Contact Info</h3>
                                    <p>Our corporate office address...</p>
                                    <div className="row">
                                        <div className="col-sm-6 col-lg-12 single-contact-info media align-items-center">
                                            <div className="image"> <img src="assets/custom_icons/contact/location(1).png" className="contact-form-icons" alt="" /> </div>
                                            <div className="media-body">
                                                <h4>Office Location</h4>
                                                <p>Hexaride Technologies (OPC) Pvt. Ltd.,
                                                Unit No. 0504,
                                                Ambuja EcoCenter, EM Block, Sector V, Salt Lake,
                                                    Kolkata – 700091.</p>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-lg-12 single-contact-info media align-items-center">
                                            <div className="image"> <img src="assets/custom_icons/contact/mobile-phone.png" className="contact-form-icons" alt="" /> </div>
                                            <div className="media-body">
                                                <h4>Office Phone</h4>
                                                <p><a href="tel:033-4600-6456" >033-4600-6456</a> <a href="tel:+919903622224">+91-9903622224</a></p>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-lg-12 single-contact-info media align-items-center">
                                            <div className="image"> <img src="assets/custom_icons/contact/whatsapp.png" className="contact-form-icons" alt="" style={{ height: 50, width: 50 }} /> </div>
                                            <div className="media-body">
                                                <h4>WhatsApp</h4>
                                                <p><a href="https://wa.me/+919903622225/">+91-9903622225</a> </p>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-lg-12 single-contact-info media align-items-center">
                                            <div className="image"> <img src="assets/custom_icons/contact/gmail.png" className="contact-form-icons" alt="" style={{ height: 50, width: 50 }} /> </div>
                                            <div className="media-body">
                                                <h4>Office Email</h4>
                                                <p><a target="_blank" href="mailto:info@hexaride.com">info@hexaride.com</a> </p>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="contact-form-wrapper">
                                    <h3>Send Us Message</h3>
                                    <p>Fill up this form to contact us if you have any futher questions.</p>
                                    <form method="POST" action="#" className="contact-form">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <input type="text" name="name" onChange={this.onNameChange} className="theme-input-style" placeholder="Your Name" required /> </div>
                                            <div className="col-md-6">
                                                <input type="email" name="email" onChange={this.onEmailChange} className="theme-input-style" placeholder="Your Email" required /> </div>
                                            <div className="col-md-6">
                                                <input type="text" name="company" onChange={this.onSubjectChange} className="theme-input-style" placeholder="Subject" required /> </div>
                                            <div className="col-md-6">
                                                <input type="tel" name="phone" onChange={this.onPhoneChange} className="theme-input-style" placeholder="Phone" required /> </div>
                                            <div className="col-12">
                                                <textarea name="message" onChange={this.onMessageChange} className="theme-input-style" required></textarea>
                                            </div>
                                            <ReCAPTCHA
                                                style={{ paddingLeft: 13, marginBottom: 20 }}
                                                sitekey="6LfYmFsUAAAAAMwfG0tUZmcXVPoHdOdS4CO1bRx_"
                                                onChange={this.onReCaptchaChange}
                                            />
                                            <div className="col-12" onClick={(e) => this.submitForm()}>
                                                <a href="javascript:void(0);" className="btn-get-the-app hover-box-effect">
                                                    <img src="assets/custom_icons/contact/direct.png" className="svg" style={{ 'width': '30px', 'height': '30px', 'marginRight': '20px' }} alt="" /> Send Message
                        </a>
                                            </div>
                                        </div>
                                        <div className="form-response"></div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}

export default withRouter(ContactForm);


// WEBPACK FOOTER //
// ./src/Pages/ContactForm.js